// extracted by mini-css-extract-plugin
export var addButton = "_mv-0";
export var border = "_mv-8";
export var check = "_mv-h";
export var danger = "_mv-6";
export var dropdownContainer = "_mv-1";
export var editModalBody = "_mv-j";
export var footerContainer = "_mv-i";
export var fullWidth = "_mv-a";
export var hide = "_mv-9";
export var icon = "_mv-3";
export var input = "_mv-7";
export var inputFlex = "_mv-b";
export var inputWrapper = "_mv-c";
export var manualFocus = "_mv-5";
export var optionButton = "_mv-4";
export var pillWrapper = "_mv-e";
export var pointer = "_mv-2";
export var showOverflow = "_mv-f";
export var tagsFlex = "_mv-d";
export var xButton = "_mv-g";